document.addEventListener('DOMContentLoaded', () => {
	const hero = document.querySelector<HTMLElement>('[data-case-hero]');
	const header = document.querySelector<HTMLElement>('[data-header]');

	if (hero && header) {
		document.addEventListener('scroll', () => {
			if (window.scrollY <= 0) {
				header.classList.add('header--transparent');
			} else {
				header.classList.remove('header--transparent');
			}
		});
	}
});
